// Updated SessionManager.js with better error handling
import firebase, { auth, db, realtimeDB } from '../firebaseConfig.js';



class SessionManager {
  constructor() {
    this.sessionId = null;
    this.initialized = false;
    this.sessionData = null;
    this.sessionDocId = null;
    this.usingFallback = false;
    this.sessionStartTime = Date.now();
  }

  // In SessionManager.js - Update the init method to add better Firebase connection debugging:

// In the init method, modify the Firebase connection check to handle CORS better:
init() {
  if (this.initialized) return;
  
  try {
    this.sessionId = Date.now().toString() + '-' + Math.random().toString(36).substr(2, 9);
    this.initialized = true;
    this.sessionStartTime = Date.now();

    // Clean up orphaned sessions first
    this.cleanupOrphanedSessions();
    
    // Record session start
    const user = auth.currentUser;
    const userId = user ? user.uid : null;
    
    if (userId) {
      // Create sessionData object with valid types only
      const sessionData = {
        userId: userId,
        sessionId: this.sessionId,
        // Use server timestamp for compatibility
        startTime: firebase.firestore.FieldValue.serverTimestamp(),
        device: navigator.userAgent || "unknown",
        inProgress: true,
        gameType: "PPTHero",
        // Add a string timestamp as a fallback
        startTimeString: new Date().toISOString()
      };
      
      // --- CHANGE: Directly attempt save ---
      console.log("Attempting to save session data...");
      this.saveSessionData(sessionData, userId); // Call the existing save method with retries
      // --- END CHANGE ---
      
      // Save to class property
   /*   this.sessionData = sessionData;
      
      // Check connection status before writing
      const connectedRef = realtimeDB.ref(".info/connected");
      connectedRef.on("value", (snap) => {
        const connected = snap.val();
        console.log("Firebase connection status:", connected ? "connected" : "disconnected");
        
        if (connected === true) {
          // Save session data to Firestore with connection confirmed
          this.saveSessionData(sessionData);
        } else {
          console.warn("Firebase connection not established, using fallback");
          this.usingFallback = true;
        }
      }, (error) => {
        console.error("Error checking connection:", error.message);
        this.usingFallback = true;
      });*/
    } else {
      console.log("No user signed in, using anonymous session");
      this.usingFallback = true;
    }
  } catch (error) {
    console.error("Exception in session initialization:", error);
    // Don't break the game if session tracking fails
    this.usingFallback = true;
    this.initialized = true; // Mark as initialized to prevent future attempts
  }
}
// Add this helper method to SessionManager class
saveSessionData(sessionData, userId) {
  console.log("Saving session data to Firestore:", Object.keys(sessionData).join(", "));
  
  // Save to class property
  this.sessionData = sessionData;
  
  // Add additional retry logic with exponential backoff
  const maxRetries = 3;
  let retryCount = 0;
  
  const attemptSave = () => {
    db.collection("sessions").add(sessionData)
      .then(docRef => {
        console.log("Session started with ID:", docRef.id);
        this.sessionDocId = docRef.id;
      })
      .catch(error => {
        console.error(`Error saving session start (attempt ${retryCount + 1}):`, error);
        
        if (retryCount < maxRetries) {
          // Exponential backoff
          retryCount++;
          const delay = Math.pow(2, retryCount) * 1000;
          console.log(`Retrying in ${delay}ms...`);
          setTimeout(attemptSave, delay);
        } else {
          // Fallback if Firebase save fails after retries
          console.log("Maximum retries reached. Using fallback session tracking");
          this.usingFallback = true;
        }
      });
  };
  
  // Start the first attempt
  attemptSave();
}

  getSessionId() {
    if (!this.initialized) {
      this.init();
    }
    return this.sessionId;
  }

  endSession() {
    if (this.usingFallback) {
      console.log("Using fallback session - not saving to Firebase");
      return;
    }
    
    const user = auth.currentUser;
    const userId = user ? user.uid : null;
    
    if (userId && this.sessionId) {
      try {
        // If we have the document ID stored, use it directly
        if (this.sessionDocId) {
          db.collection("sessions").doc(this.sessionDocId).update({
            endTime: firebase.firestore.FieldValue.serverTimestamp(),
            endTimeString: new Date().toISOString(),
            duration: (Date.now() - this.sessionStartTime) / 1000,
            levelsPlayed: 0,
            inProgress: false
          }).catch(error => {
            console.error("Error updating session with direct ID:", error);
          });
        } else {
          // Otherwise query for it
          db.collection("sessions")
            .where("sessionId", "==", this.sessionId)
            .where("userId", "==", userId)
            .get()
            .then((snapshot) => {
              if (!snapshot.empty) {
                snapshot.forEach((doc) => {
                  try {
                    // Use server timestamp for endTime
                    doc.ref.update({
                      endTime: firebase.firestore.FieldValue.serverTimestamp(),
                      endTimeString: new Date().toISOString(),
                      duration: (Date.now() - this.sessionStartTime) / 1000,
                      levelsPlayed: 0,
                      inProgress: false
                    });
                  } catch (error) {
                    console.error("Error updating session document:", error);
                  }
                });
              }
            })
            .catch(error => {
              console.error("Error querying for session:", error);
            });
        }
      } catch (error) {
        console.error("Exception in endSession:", error);
      }
    }
  }
  
  async cleanupOrphanedSessions() {
    try {
      const user = auth.currentUser;
      if (!user) return;
      
      // Find any sessions that are still marked as in progress
      const sessionsSnapshot = await db.collection("sessions")
        .where("userId", "==", user.uid)
        .where("inProgress", "==", true)
        .get();
      
      if (sessionsSnapshot.empty) return;
      
      console.log(`Found ${sessionsSnapshot.size} orphaned sessions to clean up`);
      
      // Update each session to mark it as ended
      const batch = db.batch();
      const now = new Date();
      
      sessionsSnapshot.forEach(doc => {
        const data = doc.data();
        const startTime = data.startTime?.toDate?.() || 
                         new Date(data.startTimeString || 0);
        
        // Calculate duration (cap at 24 hours to avoid unreasonable values)
        const maxDuration = 24 * 60 * 60; // 24 hours in seconds
        const duration = Math.min(
          maxDuration, 
          (now.getTime() - startTime.getTime()) / 1000
        );
        
        batch.update(doc.ref, {
          endTime: firebase.firestore.FieldValue.serverTimestamp(),
          endTimeString: now.toISOString(),
          duration: duration,
          inProgress: false,
          endReason: 'orphaned'
        });
      });
      
      await batch.commit();
      console.log(`Cleaned up ${sessionsSnapshot.size} orphaned sessions`);
    } catch (error) {
      console.error("Error cleaning up orphaned sessions:", error);
    }
  }
  reset() {
    try {
      // End the current session properly before resetting
      if (this.initialized && !this.usingFallback) {
        this.endSession();
      }
      
      // Reset all properties
      this.sessionId = null;
      this.initialized = false;
      this.sessionData = null;
      this.sessionDocId = null;
      this.usingFallback = false;
      this.sessionStartTime = Date.now();
      
      console.log("Session manager reset complete");
    } catch (error) {
      console.error("Error during session reset:", error);
    }
  }
}

// Export a singleton instance
const sessionManager = new SessionManager();

// Make it available globally for debugging
if (typeof window !== 'undefined') {
  window.sessionManager = sessionManager;
}

export default sessionManager;